import script from "./ThemeChange.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeChange.vue?vue&type=script&setup=true&lang=js"

import "./ThemeChange.vue?vue&type=style&index=0&id=51209dd3&lang=scss&scoped=true"

import exportComponent from "/Users/ntt/Documents/projects/foxartbox.com/www/fab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51209dd3"]])

export default __exports__